// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","Top":"10000","wrapper":"Gaaf2d6","isExpanded":"G2e622e"};